<template>
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />

        <div class="card">
          <div class="card-body">
            <div v-if="loading" class="loading-wrap">
              <div class="loading-spinner"></div>
              <span>Loading sale details...</span>
            </div>

            <template v-else>
              <div class="row mb-3">
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label class="form-label">Customer</label>
                    <b-form-select v-model="form.customerid" :options="customerOptions" class="form-ctrl" @change="syncCustomerSelection" />
                  </div>
                </div>
                <div class="col-lg-2 col-sm-6 col-12">
                  <div class="form-group">
                    <label class="form-label">Bill Date</label>
                    <b-form-input type="date" v-model="form.billdate" class="form-ctrl" />
                  </div>
                </div>
                <div class="col-lg-2 col-sm-6 col-12">
                  <div class="form-group">
                    <label class="form-label">Payment Mode</label>
                    <b-form-select v-model="form.paymentmode" :options="paymentModeOptions" class="form-ctrl" />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label class="form-label">Remarks</label>
                    <b-form-input v-model="form.remarks" class="form-ctrl" />
                  </div>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-lg-4 col-sm-6 col-12">
                  <div class="info-box">
                    <div><span class="info-label">Name</span><strong>{{ form.customername || "—" }}</strong></div>
                    <div><span class="info-label">Mobile</span><strong>{{ form.mobile || "—" }}</strong></div>
                    <div><span class="info-label">GST</span><strong>{{ form.gstno || "—" }}</strong></div>
                  </div>
                </div>
                <div class="col-lg-8 col-sm-6 col-12">
                  <div class="info-box">
                    <div><span class="info-label">Address</span><strong>{{ form.address || "—" }}</strong></div>
                  </div>
                </div>
              </div>

              <div class="purchase-table-outer">
                <table class="purchase-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Item</th>
                      <th>Purchase Layer</th>
                      <th>Qty</th>
                      <th>Free</th>
                      <th>Rate</th>
                      <th>Discount</th>
                      <th>Amount</th>
                      <th>Tax %</th>
                      <th>Tax Amt</th>
                      <th>Batch</th>
                      <th>Exp</th>
                      <th>Total</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in form.items" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>
                        <b-form-select
                          v-model="item.itemid"
                          :options="itemOptions"
                          class="pt-input"
                          @change="onItemChange(item, $event)"
                        />
                      </td>
                      <td>
                        <b-form-select
                          v-model="item.selectedPurchaseItemId"
                          :options="item.layerOptions"
                          class="pt-input layer-input"
                          :disabled="!item.layerOptions.length"
                          @change="onLayerChange(item, $event)"
                        />
                      </td>
                      <td><b-form-input type="number" v-model.number="item.quantity" min="0" class="pt-input" @input="calculateItemTotal(item)" /></td>
                      <td><b-form-input type="number" v-model.number="item.freequantity" min="0" class="pt-input" /></td>
                      <td><b-form-input type="number" v-model.number="item.rate" min="0" class="pt-input" @input="calculateItemTotal(item)" /></td>
                      <td><b-form-input type="number" v-model.number="item.discount" min="0" class="pt-input" @input="calculateItemTotal(item)" /></td>
                      <td><b-form-input type="number" v-model.number="item.amount" class="pt-input pt-input-ro" readonly /></td>
                      <td><b-form-input type="number" v-model.number="item.taxpercent" min="0" max="100" class="pt-input" @input="calculateItemTotal(item)" /></td>
                      <td><b-form-input type="number" v-model.number="item.taxamount" class="pt-input pt-input-ro" readonly /></td>
                      <td><b-form-input v-model="item.batchno" class="pt-input" /></td>
                      <td><b-form-input type="date" v-model="item.expirydate" class="pt-input" /></td>
                      <td><b-form-input type="number" v-model.number="item.rowtotal" class="pt-input pt-input-ro" readonly /></td>
                      <td>
                        <button v-if="form.items.length > 1" class="del-btn" @click="removeItem(index)">×</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="mt-2 mb-3">
                <span @click="addItem" class="add-item-btn">+ Add Item</span>
              </div>

              <div class="row justify-content-end mb-4">
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <div class="totals-box">
                    <div class="totals-row">
                      <span>Total Amount</span>
                      <strong>₹ {{ formatCurrency(totals.totalAmount) }}</strong>
                    </div>
                    <div class="totals-row">
                      <span>Discount Amount</span>
                      <strong>₹ {{ formatCurrency(totals.totalDiscount) }}</strong>
                    </div>
                    <div class="totals-row">
                      <span>Tax Amount</span>
                      <strong>₹ {{ formatCurrency(totals.totalTax) }}</strong>
                    </div>
                    <div class="totals-row">
                      <span>Round Off</span>
                      <b-form-input type="number" v-model.number="form.roundoff" class="totals-input" @input="computeTotals" />
                    </div>
                    <div class="totals-row totals-net-row">
                      <span>Net Amount</span>
                      <strong>₹ {{ formatCurrency(totals.netAmount) }}</strong>
                    </div>
                  </div>
                </div>
              </div>

              <div class="d-flex gap-2">
                <button @click="updateSale" class="btn-submit-custom" :disabled="submitting">
                  {{ submitting ? "Updating..." : "Update Sale" }}
                </button>
                <router-link to="/saleslist" class="btn-cancel-custom">Cancel</router-link>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import Swal from "sweetalert2";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post["Content-Type"] = "application/json;charset=utf-8";
axios.defaults.headers.common["api-key"] = process.env.VUE_APP_API_KEY;

const emptyItem = () => ({
  itemid: "",
  itemname: "",
  quantity: 0,
  freequantity: 0,
  rate: 0,
  discount: 0,
  amount: 0,
  taxpercent: 0,
  cgst: 0,
  sgst: 0,
  igst: 0,
  taxamount: 0,
  purchaseitemid: null,
  selectedPurchaseItemId: null,
  layerOptions: [],
  allLayers: [],
  layerMap: {},
  layerRemainingQty: 0,
  _layerRequestId: 0,
  batchno: "",
  expirydate: "",
  rowtotal: 0,
});

export default {
  name: "edit-sales",
  data() {
    return {
      title: "Edit Sale",
      title1: "Update bill and all items",
      saleid: this.$route.query.id || "",
      loading: false,
      submitting: false,
      form: {
        billno: "",
        billdate: "",
        customerid: "",
        customername: "",
        mobile: "",
        address: "",
        gstno: "",
        locationid: this.$store.getters.getCurrentLocation?.locationid || "",
        paymentmode: "Cash",
        roundoff: 0,
        remarks: "",
        items: [],
      },
      totals: {
        totalAmount: 0,
        totalDiscount: 0,
        totalTax: 0,
        netAmount: 0,
      },
      paymentModeOptions: [
        { value: "Cash", text: "Cash" },
        { value: "Card", text: "Card" },
        { value: "UPI", text: "UPI" },
        { value: "Bank Transfer", text: "Bank Transfer" },
        { value: "Credit", text: "Credit" },
      ],
      itemListFromApi: [],
      customerListFromApi: [],
    };
  },
  computed: {
    customerOptions() {
      return [
        { value: "", text: "Select Customer" },
        ...this.customerListFromApi.map((c) => ({
          value: c.customerid,
          text: c.customername ? `${c.customername} (${c.customerid})` : c.customerid,
        })),
      ];
    },
    itemOptions() {
      return [
        { value: "", text: "Select Item" },
        ...this.itemListFromApi.map((i) => ({ value: i.itemid, text: i.itemname })),
      ];
    },
    locationOptions() {
      return (this.$store.getters.getLocations || []).map((location) => ({
        value: location.locationid,
        text: location.locationname,
      }));
    },
  },
  beforeMount() {
    this.saleid = this.$route.query.id;
    this.bootstrap();
  },
  watch: {
    "form.locationid": {
      async handler(newValue, oldValue) {
        if (!newValue || newValue === oldValue) return;
        const rows = this.form.items.filter((item) => item.itemid);
        await Promise.all(rows.map((item) => this.fetchPurchaseLayers(item)));
      },
    },
  },
  methods: {
    formatCurrency(value) {
      return Number(value || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    formatDateOnly(value) {
      if (!value) return "";
      const d = new Date(value);
      if (isNaN(d)) return "";
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${y}-${m}-${day}`;
    },
    syncCustomerSelection() {
      const customer = this.customerListFromApi.find((c) => c.customerid === this.form.customerid);
      this.form.customername = customer?.customername || "";
      this.form.mobile = customer?.mobile || "";
      this.form.address = customer?.address || "";
      this.form.gstno = customer?.gstno || "";
    },
    async onItemChange(item, selectedItemId = null) {
      const previousItemId = item.itemid;
      item.itemid = selectedItemId || item.itemid;
      const selected = this.itemListFromApi.find((opt) => opt.itemid === item.itemid);
      item.itemname = selected?.itemname || "";
      item.selectedPurchaseItemId = null;
      item.purchaseitemid = null;
      item.layerOptions = [];
      item.allLayers = [];
      item.layerMap = {};
      item.layerRemainingQty = 0;
      item.batchno = "";
      item.expirydate = "";
      item.rate = 0;
      item.taxpercent = 0;
      item.taxamount = 0;
      item.amount = 0;
      item.rowtotal = 0;

      if (!item.itemid) {
        this.calculateItemTotal(item);
        return;
      }

      await this.fetchPurchaseLayers(item);
      this.refreshLayerOptionsForItem(previousItemId);
      if (!item.layerOptions.length && selected) {
        item.rate = Number(selected.mrp || item.rate || 0);
        item.taxpercent = Number(selected.taxpercent || item.taxpercent || 0);
        this.calculateItemTotal(item);
      }
    },
    hydrateLayerDetails(item, data) {
      item.selectedPurchaseItemId = data.purchaseitemid ?? item.selectedPurchaseItemId;
      item.purchaseitemid = data.purchaseitemid ?? item.purchaseitemid;
      item.rate = Number(data.mrp ?? data.unitprice ?? item.rate ?? 0);
      item.taxpercent = Number(data.taxpercent ?? item.taxpercent ?? 0);
      item.batchno = data.batchno ?? item.batchno ?? "";
      item.expirydate = this.formatDateOnly(data.expirydate ?? item.expirydate);
      item.layerRemainingQty = Number(data.remainingqty ?? data.available ?? item.layerRemainingQty ?? 0);
      item.itemname = data.itemname || item.itemname || item.itemid;
      this.calculateItemTotal(item);
    },

    refreshLayerOptionsForItem(itemid) {
      if (!itemid) return;

      const rows = this.form.items.filter((r) => r.itemid === itemid);
      const used = new Set();

      rows.forEach((row) => {
        const usedBefore = new Set(used);
        const allLayers = Array.isArray(row.allLayers) ? row.allLayers : [];

        let selection = row.selectedPurchaseItemId || row.purchaseitemid || null;
        if (selection != null && usedBefore.has(String(selection))) {
          selection = null;
        }

        if (selection == null) {
          const next = allLayers.find((layer) => !usedBefore.has(String(layer.purchaseitemid)));
          if (next) {
            row.selectedPurchaseItemId = next.purchaseitemid;
            row.purchaseitemid = next.purchaseitemid;
            this.hydrateLayerDetails(row, next);
            selection = next.purchaseitemid;
          } else {
            row.selectedPurchaseItemId = null;
            row.purchaseitemid = null;
            row.layerOptions = [];
            row.layerRemainingQty = 0;
            return;
          }
        } else {
          row.selectedPurchaseItemId = selection;
          row.purchaseitemid = selection;
        }

        const selectionStr = String(selection);
        row.layerOptions = allLayers
          .filter((layer) => {
            const layerId = String(layer.purchaseitemid);
            return layerId === selectionStr || !usedBefore.has(layerId);
          })
          .map((layer) => ({
            value: layer.purchaseitemid,
            text: `${layer.billno || layer.purchaseid} | Batch ${layer.batchno || "-"} | Rem ${layer.remainingqty}`,
          }));

        used.add(selectionStr);
      });
    },

    async fetchPurchaseLayers(item) {
      if (!item.itemid) return;

      try {
        const requestId = (item._layerRequestId || 0) + 1;
        item._layerRequestId = requestId;
        const requestedItemId = item.itemid;
        const res = await axios.get(`/v1/sales/purchase-layers/${item.itemid}`, {
          params: {
            locationid: this.form.locationid || this.$store.getters.getCurrentLocation?.locationid || undefined,
          },
        });
        if (item._layerRequestId !== requestId || item.itemid !== requestedItemId) return;
        const layers = Array.isArray(res.data) ? res.data : [];
        item.allLayers = layers;
        item.layerMap = layers.reduce((acc, layer) => {
          acc[String(layer.purchaseitemid)] = layer;
          return acc;
        }, {});

        this.refreshLayerOptionsForItem(item.itemid);

        const selectedId = item.selectedPurchaseItemId || item.purchaseitemid || null;
        if (selectedId && item.layerMap[String(selectedId)]) {
          this.hydrateLayerDetails(item, item.layerMap[String(selectedId)]);
          return;
        }

        if (item.layerOptions.length) {
          const firstId = item.layerOptions[0].value;
          if (item.layerMap[String(firstId)]) {
            this.hydrateLayerDetails(item, item.layerMap[String(firstId)]);
            return;
          }
        }

        item.layerRemainingQty = 0;
      } catch (error) {
        console.error(error);
      }
    },
    onLayerChange(item, selectedPurchaseItemId) {
      item.selectedPurchaseItemId = selectedPurchaseItemId;
      item.purchaseitemid = selectedPurchaseItemId;
      const layer = item.layerMap?.[String(selectedPurchaseItemId)];
      if (!layer) return;
      this.hydrateLayerDetails(item, layer);
      this.refreshLayerOptionsForItem(item.itemid);
    },
    calculateItemTotal(item) {
      const qty = Number(item.quantity || 0);
      const rate = Number(item.rate || 0);
      const discount = Number(item.discount || 0);
      const taxPct = Number(item.taxpercent || 0);
      const amount = Math.max(0, qty * rate - discount);
      const taxAmt = amount * taxPct / 100;

      item.amount = Number(amount.toFixed(2));
      item.taxamount = Number(taxAmt.toFixed(2));
      item.cgst = Number((taxAmt / 2).toFixed(2));
      item.sgst = Number((taxAmt / 2).toFixed(2));
      item.igst = 0;
      item.rowtotal = Number((amount + taxAmt).toFixed(2));

      this.computeTotals();
    },
    computeTotals() {
      const totalAmount = this.form.items.reduce((sum, item) => sum + Number(item.quantity || 0) * Number(item.rate || 0), 0);
      const totalDiscount = this.form.items.reduce((sum, item) => sum + Number(item.discount || 0), 0);
      const totalTax = this.form.items.reduce((sum, item) => sum + Number(item.taxamount || 0), 0);
      const roundoff = Number(this.form.roundoff || 0);

      this.totals.totalAmount = Number(totalAmount.toFixed(2));
      this.totals.totalDiscount = Number(totalDiscount.toFixed(2));
      this.totals.totalTax = Number(totalTax.toFixed(2));
      this.totals.netAmount = Number((totalAmount - totalDiscount + totalTax + roundoff).toFixed(2));
    },
    addItem() {
      if (this.form.items.length >= 20) {
        Swal.fire({ icon: "warning", title: "Limit Reached", text: "Maximum 20 items per sale." });
        return;
      }
      this.form.items.push(emptyItem());
    },
    removeItem(index) {
      const removedItemId = this.form.items[index]?.itemid;
      this.form.items.splice(index, 1);
      this.refreshLayerOptionsForItem(removedItemId);
      this.computeTotals();
    },
    mapItem(item) {
      const mapped = {
        ...emptyItem(),
        ...item,
        itemname: item.itemname || this.itemListFromApi.find((opt) => opt.itemid === item.itemid)?.itemname || item.itemid,
        expirydate: this.formatDateOnly(item.expirydate),
      };

      const savedAmount = Number(mapped.amount || (Number(mapped.quantity || 0) * Number(mapped.rate || 0) - Number(mapped.discount || 0)));
      const savedTaxAmount = Number(mapped.taxamount || 0);

      mapped.amount = Number(savedAmount.toFixed(2));
      mapped.taxamount = Number(savedTaxAmount.toFixed(2));
      mapped.cgst = Number((mapped.cgst || savedTaxAmount / 2).toFixed(2));
      mapped.sgst = Number((mapped.sgst || savedTaxAmount / 2).toFixed(2));
      mapped.rowtotal = Number((savedAmount + savedTaxAmount).toFixed(2));
      mapped.purchaseitemid = item.purchaseitemid || null;
      mapped.selectedPurchaseItemId = item.purchaseitemid || null;

      return mapped;
    },
    async fetchItemNamesForSale(items) {
      const missing = items
        .filter((item) => !this.itemListFromApi.find((opt) => opt.itemid === item.itemid))
        .map((item) => item.itemid);

      await Promise.all([...new Set(missing)].map(async (itemid) => {
        try {
          const res = await axios.get(`/v1/sales/items/${itemid}`);
          if (res.data?.itemid) this.itemListFromApi.push(res.data);
        } catch (error) {
          console.error(error);
        }
      }));
    },
    async bootstrap() {
      this.loading = true;
      try {
        const [itemRes, customerRes, saleRes] = await Promise.all([
          axios.get("/v1/sales/items", { params: { stocked_only: true } }),
          axios.get("/v1/customers"),
          axios.get(`/v1/sales/${this.saleid}`),
        ]);

        this.itemListFromApi = Array.isArray(itemRes.data) ? itemRes.data : (itemRes.data.items || []);
        this.customerListFromApi = customerRes.data || [];

        const sale = saleRes.data;
        await this.fetchItemNamesForSale(sale.items || []);

        this.form.billno = sale.billno || "";
        this.form.billdate = this.formatDateOnly(sale.billdate);
        this.form.customerid = sale.customerid || "";
        this.form.customername = sale.customername || "";
        this.form.mobile = sale.mobile || "";
        this.form.address = "";
        this.form.gstno = "";
        this.form.locationid = sale.locationid || this.$store.getters.getCurrentLocation?.locationid || "";
        this.form.paymentmode = sale.paymentmode || "Cash";
        this.form.roundoff = Number(sale.roundoff || 0);
        this.form.remarks = sale.remarks || "";
        this.form.items = (sale.items || []).map(this.mapItem);
        await Promise.all(this.form.items.map((item) => this.fetchPurchaseLayers(item)));

        this.syncCustomerSelection();
        this.computeTotals();
      } catch (error) {
        console.error(error);
        Swal.fire({ icon: "error", title: "Error", text: "Failed to load sale details." });
      } finally {
        this.loading = false;
      }
    },
    validateForm() {
      if (!this.form.billdate) {
        Swal.fire({ icon: "error", title: "Validation Error", text: "Bill date is required." });
        return false;
      }
      if (this.form.items.some((item) => !item.itemid)) {
        Swal.fire({ icon: "error", title: "Validation Error", text: "Item is required for every row." });
        return false;
      }
      if (this.form.items.some((item) => Number(item.quantity || 0) <= 0)) {
        Swal.fire({ icon: "error", title: "Validation Error", text: "Quantity must be greater than 0." });
        return false;
      }
      return true;
    },
    async updateSale() {
      if (!this.validateForm()) return;

      const result = await Swal.fire({
        title: "Update Sale?",
        text: "Save these changes?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#FF9F43",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, update it!",
      });
      if (!result.isConfirmed) return;

      this.submitting = true;
      const payload = {
        billno: this.form.billno || null,
        billdate: moment(this.form.billdate).format("YYYY-MM-DD"),
        locationid: this.form.locationid || null,
        customerid: this.form.customerid || null,
        customername: this.form.customername || null,
        mobile: this.form.mobile || null,
        totalamount: this.totals.totalAmount,
        discountamount: this.totals.totalDiscount,
        taxamount: this.totals.totalTax,
        roundoff: Number(this.form.roundoff || 0),
        netamount: this.totals.netAmount,
        paymentmode: this.form.paymentmode || null,
        remarks: this.form.remarks || null,
        items: this.form.items.map((item) => ({
          itemid: item.itemid,
          locationid: this.form.locationid || null,
          purchaseitemid: item.selectedPurchaseItemId || item.purchaseitemid || null,
          quantity: Number(item.quantity || 0),
          rate: Number(item.rate || 0),
          taxpercent: item.taxpercent || null,
          cgst: item.cgst || null,
          sgst: item.sgst || null,
          igst: item.igst || null,
          discount: item.discount || null,
          taxamount: item.taxamount || null,
          amount: item.amount || null,
          batchno: item.batchno || null,
          expirydate: item.expirydate || null,
          freequantity: Number(item.freequantity || 0),
        })),
      };

      axios.put(`/v1/sales/${this.saleid}`, payload)
        .then(() => {
          Swal.fire({ icon: "success", title: "Updated!", timer: 1500, showConfirmButton: false });
          this.$router.push({ path: "/saleslist" });
        })
        .catch((error) => {
          console.error(error);
          Swal.fire({ icon: "error", title: "Update Failed", text: error.response?.data?.detail || "Something went wrong." });
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>

<style scoped>
.loading-wrap { display:flex; flex-direction:column; align-items:center; justify-content:center; padding:60px 20px; gap:14px; color:#6b7280; }
.loading-spinner { width:36px; height:36px; border:3px solid #f3f4f6; border-top-color:#fb923c; border-radius:50%; animation:spin .7s linear infinite; }
@keyframes spin { to { transform:rotate(360deg); } }
.form-label { font-size:.78rem; font-weight:600; color:#6b7280; margin-bottom:5px; display:block; }
.form-ctrl { height:36px; font-size:.875rem; border:1px solid #e5e7eb; border-radius:6px; padding:0 10px; }
.info-box { height:100%; border:1px solid #e5e7eb; border-radius:8px; background:#f9fafb; padding:12px 14px; display:flex; gap:18px; flex-wrap:wrap; }
.info-label { display:block; font-size:.72rem; font-weight:600; color:#6b7280; margin-bottom:3px; text-transform:uppercase; }
.purchase-table-outer { overflow-x:auto; border:1px solid #e5e7eb; border-radius:8px; }
.purchase-table { width:100%; border-collapse:collapse; min-width:1320px; }
.purchase-table th { background:#f9fafb; font-size:.72rem; color:#6b7280; text-transform:uppercase; padding:9px 8px; border-bottom:1px solid #e5e7eb; }
.purchase-table td { padding:6px 8px; border-bottom:1px solid #f3f4f6; }
.pt-input { min-width:90px; height:30px; font-size:.8rem; }
.layer-input { min-width:260px; }
.pt-input-ro { background:#f9fafb !important; }
.add-item-btn { display:inline-flex; align-items:center; gap:6px; padding:6px 14px; background:#fff7f0; color:#ea580c; border:1.5px dashed #fdba74; border-radius:6px; font-size:.85rem; font-weight:600; cursor:pointer; }
.totals-box { border:1px solid #e5e7eb; border-radius:8px; overflow:hidden; background:#fff; }
.totals-row { display:flex; justify-content:space-between; align-items:center; padding:10px 14px; border-bottom:1px solid #f3f4f6; gap:12px; }
.totals-input { width:120px; height:30px; text-align:right; font-size:.85rem; }
.totals-net-row { background:#fff7f0; color:#ea580c; font-weight:700; }
.btn-submit-custom { padding:9px 24px; background:#ea580c; color:#fff; border:none; border-radius:7px; font-size:.875rem; font-weight:600; }
.btn-cancel-custom { display:inline-flex; align-items:center; padding:9px 20px; background:#f3f4f6; color:#374151; border:1px solid #e5e7eb; border-radius:7px; text-decoration:none; }
.del-btn { width:26px; height:26px; border:none; border-radius:50%; background:#fee2e2; color:#b91c1c; font-weight:700; }
</style>
